import { Tab, Tabs } from 'react-bootstrap';
import { Row } from '@raptormaps/layout';
import { CircularProgress } from '@raptormaps/progress';

// Tabs
import DataCollectionTab from './dataCollectionTab';
import FlightBoundaryTab from './flightBoundaryTab';
import OrderConstructionTab from './OrderConstructionTab';
import OrderDataTab from './OrderDataTab';
import OrderEditDetailsTab from './OrderEditDetailsTab/OrderEditDetailsTab';
import OrderFinancialsTab from './OrderFinancialsTab';
import WorkflowTab from './workflowTab';

// Types
import type { Order } from '../../../../api/schemas/OrderSchema';
import type { Org } from '../../../../api/schemas/OrgSchema';
import type { SolarFarm } from '../../../../api/schemas/SolarFarmSchema';

interface OrderEditTabsProps {
  solarFarm: SolarFarm | null;
  selectedOrder: Order | undefined;
  orderActions: any;
  orgs: Org[];
}

const OrderEditTabs = ({
  solarFarm,
  selectedOrder,
  orderActions,
  orgs,
}: OrderEditTabsProps) => {
  return (
    <>
      {selectedOrder ? (
        <Tabs id="order-edit-modal-tabs" defaultActiveKey="workflow">
          <Tab eventKey="workflow" title="Workflow">
            <WorkflowTab
              // @ts-expect-error js/ts issues?
              order={selectedOrder}
              orderActions={orderActions}
            />
          </Tab>
          <Tab eventKey="details" title="Details">
            <OrderEditDetailsTab
              order={selectedOrder}
              solarFarm={solarFarm}
              orderActions={orderActions}
              orgs={orgs}
            />
          </Tab>
          <Tab eventKey="data" title="Data">
            {/* @ts-expect-error js/ts issues? */}
            <OrderDataTab order={selectedOrder} solarFarm={solarFarm} />
          </Tab>
          <Tab eventKey="financials" title="Accounting">
            <OrderFinancialsTab
              order={selectedOrder}
              orderActions={orderActions}
            />
          </Tab>
          <Tab eventKey="data-collection" title="Data Collection">
            <DataCollectionTab
              order={selectedOrder}
              orderActions={orderActions}
              orgs={orgs}
            />
          </Tab>
          <Tab eventKey="flight-boundary" title="Flight Boundary">
            <FlightBoundaryTab
              order={selectedOrder}
              orderActions={orderActions}
              solarFarm={solarFarm}
            />
          </Tab>
          <Tab eventKey="construction-order" title="Construction">
            <OrderConstructionTab order={selectedOrder} />
          </Tab>
        </Tabs>
      ) : (
        <Row align="center" justify="center" style={{ padding: 24 }}>
          <CircularProgress size={75} />
        </Row>
      )}
    </>
  );
};

export default OrderEditTabs;
